import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS,
} from "./actionTypes"

import { 
  getCallSourceSettingStickyColumnsError,
  getCallSourceSettingStickyColumnsSuccess,
  getLeadSourceSettingStickyColumnsError,
  getLeadSourceSettingStickyColumnsSuccess,
  getSourceSettingStickyColumnsError, 
  getSourceSettingStickyColumnsSuccess, 
  updateCallSourceSettingStickyColumnsError, 
  updateCallSourceSettingStickyColumnsSuccess, 
  updateLeadSourceSettingStickyColumnsError, 
  updateLeadSourceSettingStickyColumnsSuccess, 
  updateSourceSettingStickyColumnsError, 
  updateSourceSettingStickyColumnsSuccess } from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetSourceSettingStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_source_settings`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getSourceSettingStickyColumnsError(error))
  }
}

function* onUpdateSourceSettingStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_source_settings/${action?.payload?.user_column_preference_source_setting?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateSourceSettingStickyColumnsError(error))
  }
}

function* onGetLeadCallSourceSettingStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_lead_source_settings`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLeadSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getLeadSourceSettingStickyColumnsError(error))
  }
}

function* onUpdateLeadSourceSettingStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_lead_source_settings/${action?.payload?.user_column_preference_source_setting?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateLeadSourceSettingStickyColumnsError(error))
  }
}

function* onGetCallSourceSettingStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_call_source_settings`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCallSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCallSourceSettingStickyColumnsError(error))
  }
}

function* onUpdateCallSourceSettingStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_call_source_settings/${action?.payload?.user_column_preference_source_setting?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCallSourceSettingStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCallSourceSettingStickyColumnsError(error))
  }
}

function* userSourceSettingColumnPreferenceSaga() {
  yield takeEvery(GET_SOURCE_SETTINGS_STICKY_COLUMNS, onGetSourceSettingStickyColumns)
  yield takeEvery(UPDATE_SOURCE_SETTING_STICKY_COLUMNS, onUpdateSourceSettingStickyColumns)
  yield takeEvery(GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS, onGetLeadCallSourceSettingStickyColumns)
  yield takeEvery(UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS, onUpdateLeadSourceSettingStickyColumns)
  yield takeEvery(GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS, onGetCallSourceSettingStickyColumns)
  yield takeEvery(UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS, onUpdateCallSourceSettingStickyColumns)
}

export default userSourceSettingColumnPreferenceSaga;
